import { EventEmitter, Injectable, Output } from "@angular/core";
import { Scheduler } from "@bryntum/scheduler-thin";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SchedulerService {
  @Output() schedulerEvents = new EventEmitter<object>();
  private _schedulerBehaviour: BehaviorSubject<Scheduler | null> =
    new BehaviorSubject<Scheduler | null>(null);

  constructor() {}

  public get scheduler(): BehaviorSubject<Scheduler | null> {
    return this._schedulerBehaviour;
  }

  public updateScheduler(scheduler: Scheduler | null) {
    this._schedulerBehaviour.next(scheduler);
  }
}
